module.exports = __webpack_public_path__ + "static/media/10.7bd3330f.png";